import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

type TUseDeleteGoalFocusAreaMutation = {
  focusAreaId: string;
  options?: any;
};

export const useDeleteGoalFocusAreaMutation = ({
  focusAreaId,
  options,
}: TUseDeleteGoalFocusAreaMutation) => {
  const { goalId } = useParams();

  const { request } = useMutationHTTPRequest();

  return useMutation(
    () =>
      request({
        url: `/api/web/goals/${goalId}/breakdown/focus-areas/delete`,
        body: { focusAreaId },
      }),
    {
      ...options,
    }
  );
};
